import { EMPTY_LIST } from '../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../constants/validation'

export const REQUEST_FORM_FIELD_NAME_APPLICANT = 'owner'

export const REQUEST_FORM_FIELD_NAME_BUILDING = 'building'

export const REQUEST_FORM_FIELD_NAME_CATEGORY = 'category'

export const REQUEST_FORM_FIELD_NAME_DATE = 'due_date'

export const REQUEST_FORM_FIELD_NAME_DESCRIPTION = 'text'

export const REQUEST_FORM_FIELD_NAME_CHAT_MESSAGE = 'chat_message'

export const REQUEST_FORM_FIELD_NAME_EMAIL_MESSAGE = 'email_message' // Email message ID

export const REQUEST_FORM_FIELD_NAME_IS_CHATROOM_PUBLIC = 'is_chatroom_public'

export const REQUEST_FORM_FIELD_NAME_FILES = 'files'

export const REQUEST_FORM_FIELD_NAME_FLAT = 'flat'

export const REQUEST_FORM_FIELD_NAME_MANAGER = 'assignees'

export const REQUEST_FORM_FIELD_NAME_RELATED_REQUESTS = 'related_request_ids'

export const REQUEST_FORM_FIELD_NAME_VIEWER = 'viewer'

export const REQUEST_FORM_FIELD_NAME_TITLE = 'title'

export const REQUEST_FORM_INITIAL_VALUES = {
  [REQUEST_FORM_FIELD_NAME_APPLICANT]: FORMIK_EMPTY_VALUE,
  [REQUEST_FORM_FIELD_NAME_BUILDING]: FORMIK_EMPTY_VALUE,
  [REQUEST_FORM_FIELD_NAME_CATEGORY]: null,
  [REQUEST_FORM_FIELD_NAME_CHAT_MESSAGE]: null,
  [REQUEST_FORM_FIELD_NAME_DATE]: null,
  [REQUEST_FORM_FIELD_NAME_DESCRIPTION]: FORMIK_EMPTY_VALUE,
  [REQUEST_FORM_FIELD_NAME_EMAIL_MESSAGE]: null,
  [REQUEST_FORM_FIELD_NAME_FILES]: EMPTY_LIST,
  [REQUEST_FORM_FIELD_NAME_FLAT]: FORMIK_EMPTY_VALUE,
  [REQUEST_FORM_FIELD_NAME_IS_CHATROOM_PUBLIC]: null,
  [REQUEST_FORM_FIELD_NAME_MANAGER]: EMPTY_LIST,
  [REQUEST_FORM_FIELD_NAME_RELATED_REQUESTS]: EMPTY_LIST,
  [REQUEST_FORM_FIELD_NAME_TITLE]: FORMIK_EMPTY_VALUE,
}

export const REQUEST_FORM_REQUIRED_FIELDS = [
  REQUEST_FORM_FIELD_NAME_TITLE,
  REQUEST_FORM_FIELD_NAME_BUILDING,
  REQUEST_FORM_FIELD_NAME_DESCRIPTION,
  REQUEST_FORM_FIELD_NAME_FLAT,
]

export const REQUEST_FORM_REQUIRED_FIELDS_STAFF = [
  REQUEST_FORM_FIELD_NAME_TITLE,
  REQUEST_FORM_FIELD_NAME_DESCRIPTION,
]

export const REQUEST_FORM_REQUIRED_FIELDS_UNCONFIRMED = [
  REQUEST_FORM_FIELD_NAME_TITLE,
  REQUEST_FORM_FIELD_NAME_DESCRIPTION,
]

export const REQUEST_FORM_TITLE_FIELD_MAX_LENGTH = 255

export const REQUEST_FORM_MANAGERS_FIELD_MAX_ITEMS = 140

export const REQUEST_FORM_MANAGERS_FIELD_MAX_ERROR =
  'request-managers-limit-exceeded'
